// The marine layer icon (W2, Oct 26): on Current Conditions, a partly cloudy sky before noon in San Francisco is
// almost always the marine layer burning off, so ws4kp's Partly Cloudy icon becomes ours (sun over a low grey bank,
// brand/wx/current-conditions/Marine-Layer.gif). Watches the icon rather than patching ws4kp's icon table.
const { clock } = window.RHL;
const STOCK = /current-conditions\/Partly-Cloudy\.gif$/;
const MARINE = 'images/icons/current-conditions/Marine-Layer.gif';
const FROM_HOUR = 5;
const UNTIL_HOUR = 12;

const localHour = () => Number(new Intl.DateTimeFormat('en-US', { timeZone: clock.timeZone, hour: 'numeric', hourCycle: 'h23' }).format(new Date()));

const swap = (img) => {
	const src = img.getAttribute('src') ?? '';
	const hour = localHour();
	if (STOCK.test(src) && hour >= FROM_HOUR && hour < UNTIL_HOUR) img.setAttribute('src', MARINE);
};

const watch = () => {
	const img = document.querySelector('#current-weather-html .icon img');
	if (!img) return false;
	swap(img);
	new MutationObserver(() => swap(img)).observe(img, { attributes: true, attributeFilter: ['src'] });
	return true;
};

if (!watch()) document.addEventListener('DOMContentLoaded', watch, { once: true });
